import styled from 'styled-components'
import FooterBackground from '../../images/background-footer.png'
import Container from '../container/index'
import globals from '../globals'

export const FooterWrapper = styled.footer`
  background: url(${FooterBackground}) no-repeat center top;
  padding-top:172px;
  padding-bottom:4px;
  font-size:15px;
  position:relative;

  @media ${globals.mediaqueries.extraSmall}{
    background-position: center top -70px;
    padding-top: 100px;
  }

  @media ${globals.mediaqueries.small}{
    background-position: center top -70px;
    padding-top: 100px;
  }

  &:before {
    content:"";
    width:100%;
    height:50%;
    display:none;
    position:absolute;
    left:0;
    bottom:0;
    background:#f1f5fb;
    z-index:-1;
  }

  @media ${globals.mediaqueries.huge}{
    background-size: 100% 100%;
  }

  @media ${globals.mediaqueries.small}{
    &:before {
      display:block;
    }    
  }

  @media ${globals.mediaqueries.extraSmall}{
    &:before {
      display:block;
    }    
  }
`

export const FooterGrid = styled.section`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-gap: 35px;
  margin-bottom: 30px;

  @media ${globals.mediaqueries.small}{
    grid-template-columns: 1fr;
  }

  @media ${globals.mediaqueries.extraSmall}{
    grid-template-columns: 1fr;
  }

  .about {

    p {
      max-width:370px;
      font-weight: 300;
      line-height: 1.6;
    }
  }

  ul {
    margin:0;
    padding:0;
    color:#3a3864;

    li {
      display: block;

      a {
        color: inherit;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`

export const FooterSmallGridWrapper = styled.div`
  background:#e8ecf3;
  padding-top:14px;
  padding-bottom:14px;
`

export const FooterSmallGrid = styled(Container)`
  display:flex;

  p {
    margin:0;
    padding:0;
    align-self:center;
    color:#9e9fb5;
    font-size:13px;
  }

  img {
    margin:0;
  }

  nav {
    margin-right:0;
    margin-left:auto;
    padding:0;
    align-self:center;

    & > ul {
      margin:0;
      padding:0;
      list-style: none;

      & > li {
        display: inline-block;
        margin:0;
        padding:0;

        & + li {
          margin-left:15px;
        }
      }
    }
  }
`